import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Grid,
  Header,
  Segment,
  Comment,
  Image,
  Button,
} from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import EditProfile from './EditProfile';
import '../../app/common/MediaQuery/responsive-user-profile.css';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import UnauthorizedMessage from '../UnauthorizedMessage';
import UploadLogo from './UploadLogo';

function UserProfile() {
  const {
    mediaAssetStore,
    userStore,
    activityStore,
    commonStore,
    dashboardStore,
  } = useStore();
  const { activitiesByDate, activityRegistry, loadActivities } = activityStore;
  const { user } = userStore;
  const [profileImage, setProfileImage] = useState('');
  const [updateLogo, showUpdateLogo] = useState(false);

  const openEditProfileModal = () => {
    mediaAssetStore.editProfileModal(true);
  };

  useEffect(() => {
    if (activityRegistry.size <= 1) loadActivities();
    // eslint-disable-next-line
  }, [activityRegistry.size, loadActivities]);

  useEffect(() => {
    const selectedHistory = activitiesByDate.filter((x) => {
      return x.id === mediaAssetStore.mediaAsset.userSelectedHistoryId ? x : '';
    }, []);
    if (selectedHistory.length !== 0) {
      mediaAssetStore.setWorkLevelHistory(selectedHistory[0]);
    }
  }, [
    mediaAssetStore.mediaAsset.userSelectedHistoryId,
    mediaAssetStore,
    activitiesByDate,
  ]);

  useEffect(() => {
    if (
      commonStore.devEnv &&
      !user?.image?.includes('https://res.cloudinary.com')
    ) {
      const splitPath: string[] = user?.image?.split('build') || [];
      setProfileImage(splitPath[1]);
    } else {
      setProfileImage(user?.image || '');
    }
    // eslint-disable-next-line
  }, [user?.image]);

  return (
    <>
      {' '}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('UDDB1') && (
          <UnauthorizedMessage />
        )}
      {updateLogo && (
        <UploadLogo showUpdateLogo={showUpdateLogo} updateLogo={updateLogo} />
      )}
      {commonStore.filterModeOne.includes('UDDB1') && (
        <>
          <div className="large-profile-screen">
            <Segment clearing responsive={true}>
              {mediaAssetStore.mediaAsset.editProfile === true ? (
                <EditProfile />
              ) : null}
              <Header
                icon="edit"
                size="huge"
                dividing
                as="h1"
                content={
                  (userLanguage[0].MyProfile.MPPHL1 as any)?.[
                    `${commonStore.language.key}`
                  ]
                } //"Profile"
                sub
                color="grey"
              />
              <Header />
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column width={8}>
                    <Comment.Group>
                      <Header
                        as="h3"
                        //Personal
                      >
                        {
                          (userLanguage[0].MyProfile?.MPHL01 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }
                      </Header>
                      <Comment>
                        {' '}
                        <Comment.Content>
                          {' '}
                          <Comment.Text
                          //Display Name
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL01 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {user?.displayName}
                          </Comment.Text>
                          <Comment.Text
                          //User Name
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL02 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {user?.username}
                          </Comment.Text>{' '}
                          <Comment.Text
                          //Email
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL03 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {user?.email}
                          </Comment.Text>{' '}
                        </Comment.Content>{' '}
                      </Comment>
                      <Header />
                      <Header
                        as="h3"
                        //Contact Information
                      >
                        {' '}
                        {
                          (userLanguage[0].MyProfile?.MPHL02 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }
                      </Header>
                      <Comment>
                        {' '}
                        <Comment.Content>
                          {' '}
                          <Comment.Text
                          //Phone Number
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL04 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {' ' + user?.phoneNumber}
                          </Comment.Text>
                          <Comment.Text
                          //Alternate Phone Number
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL05 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {' ' + user?.alternatePhoneNumber}
                          </Comment.Text>{' '}
                        </Comment.Content>{' '}
                      </Comment>{' '}
                      <Header />{' '}
                      <Header
                        as="h3"
                        //Employeer Information
                      >
                        {' '}
                        {
                          (userLanguage[0].MyProfile?.MPHL03 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }{' '}
                      </Header>{' '}
                      <Comment>
                        <Comment.Text
                        //Customer Name
                        >
                          {
                            (userLanguage[0].MyProfile?.MPL06 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          : {' ' + user?.customerName}{' '}
                        </Comment.Text>{' '}
                        <Comment.Text
                        //Department Name
                        >
                          {
                            (userLanguage[0].MyProfile?.MPL07 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          : {' ' + user?.departmentName}
                        </Comment.Text>
                      </Comment>
                      <Header />
                      <Header
                        as="h3"
                        //Address
                      >
                        {' '}
                        {
                          (userLanguage[0].MyProfile?.MPHL04 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }{' '}
                      </Header>{' '}
                      <Comment>
                        {' '}
                        <Comment.Text
                        //Address Line 1
                        >
                          {
                            (userLanguage[0].MyProfile?.MPL08 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          : {' ' + user?.addressLine1}
                        </Comment.Text>{' '}
                        <Comment.Text
                        //Address Line 2
                        >
                          {
                            (userLanguage[0].MyProfile?.MPL09 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          : {' ' + user?.addressLine2}
                        </Comment.Text>{' '}
                      </Comment>{' '}
                    </Comment.Group>{' '}
                  </Grid.Column>{' '}
                  <Header />
                  <Grid.Column width={8}>
                    <Header />
                    {commonStore.filterModeTwo?.includes('MPB01') ? (
                      <Image
                        fluid
                        size="medium"
                        src={profileImage || '/assets/user.png'}
                        onError={(img: any) =>
                          (img.target.src = '/assets/user.png')
                        }
                      />
                    ) : (
                      <Image
                        fluid
                        size="medium"
                        className={
                          commonStore.filterModeZero?.includes('MPB01')
                            ? 'component-isDisabled'
                            : ''
                        }
                        label={{
                          as: Link,
                          corner: 'right',
                          icon: 'edit',
                          to:
                            commonStore.filterModeOne?.includes('MPB01') &&
                            `/profile/${userStore.user?.displayName}/edit`,
                        }}
                        src={profileImage || '/assets/user.png'}
                        onError={(img: any) =>
                          (img.target.src = '/assets/user.png')
                        }
                      />
                    )}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    {commonStore.filterModeTwo?.includes('MPPB01') ? (
                      <></>
                    ) : (
                      <Button
                        color="green"
                        onClick={openEditProfileModal}
                        disabled={commonStore.filterModeZero?.includes(
                          'MPPB01',
                        )}
                        //Update Profile
                      >
                        {
                          (userLanguage[0].MyProfile?.MPPB01 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }
                      </Button>
                    )}
                    {user?.roleName === 'Admin' && (
                      <Button
                        color="green"
                        onClick={() => showUpdateLogo(true)}
                      >
                        Update Logo
                      </Button>
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </div>
          <div className="small-profile-screen">
            <Segment clearing responsive={true}>
              {mediaAssetStore.mediaAsset.editProfile === true ? (
                <EditProfile />
              ) : null}
              <Header
                icon="edit"
                size="huge"
                dividing
                as="h1"
                content={
                  (userLanguage[0].User.UDDB1 as any)?.[
                    `${commonStore.language.key}`
                  ]
                } //"Profile"
                sub
                color="grey"
              />
              <Header />
              <Image
                fluid
                size="medium"
                label={{
                  as: Link,
                  corner: 'right',
                  icon: 'edit',
                  to: `/profile/${userStore.user?.displayName}/edit`,
                }}
                src={profileImage || '/assets/user.png'}
              />
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column width={16}>
                    <Comment.Group>
                      <Button
                        floated="right"
                        color="green"
                        onClick={openEditProfileModal}
                        //Update Profile
                      >
                        {
                          (userLanguage[0].MyProfile?.MPPB01 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }{' '}
                      </Button>
                      <Header
                        as="h3"
                        //Personal
                      >
                        {' '}
                        {
                          (userLanguage[0].MyProfile?.MPHL01 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }{' '}
                      </Header>
                      <Comment>
                        {' '}
                        <Comment.Content>
                          {' '}
                          <Comment.Text
                          //Display Name
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL01 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {user?.displayName}: {user?.displayName}
                          </Comment.Text>
                          <Comment.Text
                          //User Name
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL02 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {user?.username}: {user?.username}
                          </Comment.Text>{' '}
                          <Comment.Text
                          //Email
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL03 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {user?.email}: {user?.email}
                          </Comment.Text>{' '}
                        </Comment.Content>{' '}
                      </Comment>
                      <Header />
                      <Header
                        as="h3"
                        //Contact Information
                      >
                        {' '}
                        {
                          (userLanguage[0].MyProfile?.MPHL02 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }
                      </Header>
                      <Comment>
                        {' '}
                        <Comment.Content>
                          {' '}
                          <Comment.Text
                          //Phone Number
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL04 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {' ' + user?.phoneNumber}
                          </Comment.Text>
                          <Comment.Text
                          //Alternate Phone Number
                          >
                            {
                              (userLanguage[0].MyProfile?.MPL05 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            : {' ' + user?.alternatePhoneNumber}
                          </Comment.Text>{' '}
                        </Comment.Content>{' '}
                      </Comment>{' '}
                      <Header />{' '}
                      <Header
                        as="h3"
                        //Employeer Information
                      >
                        {' '}
                        {
                          (userLanguage[0].MyProfile?.MPHL03 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }{' '}
                      </Header>{' '}
                      <Comment>
                        <Comment.Text
                        //Customer Name
                        >
                          {
                            (userLanguage[0].MyProfile?.MPL06 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          : {' ' + user?.customerName}{' '}
                        </Comment.Text>{' '}
                        <Comment.Text
                        //Department Name
                        >
                          {
                            (userLanguage[0].MyProfile?.MPL07 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          : {' ' + user?.departmentName}
                        </Comment.Text>
                      </Comment>
                      <Header />
                      <Header
                        as="h3"
                        //Address
                      >
                        {' '}
                        {
                          (userLanguage[0].MyProfile?.MPHL04 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }{' '}
                      </Header>{' '}
                      <Comment>
                        {' '}
                        <Comment.Text
                        //Address Line 1
                        >
                          {
                            (userLanguage[0].MyProfile?.MPL08 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          : {' ' + user?.addressLine1}
                        </Comment.Text>{' '}
                        <Comment.Text
                        //Address Line 2
                        >
                          {
                            (userLanguage[0].MyProfile?.MPL09 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          : {' ' + user?.addressLine2}
                        </Comment.Text>{' '}
                      </Comment>{' '}
                    </Comment.Group>{' '}
                  </Grid.Column>{' '}
                </Grid.Row>
              </Grid>
            </Segment>
          </div>
        </>
      )}
    </>
  );
}

export default observer(UserProfile);
